import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useUUID } from '~/Hooks';
import { UploadedImage } from '.';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { readFileFromDataUrl } from '../../Helpers/Utils.helpers';
import { requestUploadImage } from '../../store';
import { selectImageUpload, selectLoading } from '../../store/app';

export const useImageUpload = () => {
  const dispatch = useDispatch();
  const imageUploadAction = bindActionCreators(requestUploadImage, dispatch);
  const uploadedImage = useSelector(selectImageUpload) as UploadedImage;
  const { t } = useTranslation();
  const [imageSrc, setImageSrc] = useState<string | undefined>();
  const imageUploading = useSelector(selectLoading(REQUEST_ACTIONS.UPLOAD_IMAGE));
  const [file, setFile] = useState<File>();
  const { createUUID } = useUUID();

  const handleImageFileChanged = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e !== null && e.target) {
      const file = e.target.files ? e.target.files[0] : null;
      e.target.value = '';

      if (!file) return;
      setFile(file);
      const imageData = await readFileFromDataUrl(file);
      setImageSrc(imageData);
    }
  };

  const handleImageUpload = async (imageDataUrl: string) => {
    const response = await imageUploadAction(file?.name || createUUID(), imageDataUrl);
    setImageSrc(undefined);
    return response;
  };

  return {
    handleImageFileChanged,
    handleImageUpload,
    imageUploading,
    uploadedImage,
    t,
    setImageSrc,
    imageSrc,
    file,
  };
};
